import React, { useContext, useEffect, useState } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContextProvider';
import { useForm } from 'react-hook-form';
import Logo from '../../assests/logo.png';
import axios from 'axios';
import { toast } from 'react-toastify';

function LoginFrom({ history }) {
  const [isVerified, setIsVerified] = useState(true);
  const [isVerification, setIsVerification] = useState(false);
  const [loading, setLoading] = useState(false);
  const { setCurrentUser, verifyUser } = useContext(AuthContext);
  const { register, handleSubmit, errors } = useForm();
  let serverUrl = process.env.REACT_APP_SERVER_URL;

  const submitForm = async (data) => {
    delete data.termsandconditions;
    setLoading(true);
    if (isVerified) {
      try {
        const res = await axios.post(`${serverUrl}/api/v2/auth/login`, data);
        setLoading(false);

        if (!res.data.verified) {
          toast.error('Please verify your phone number to login');
          setIsVerified(false);
          setIsVerification(true);
          return;
        }
        if (res.data.token) {
          window.localStorage.setItem('token', res.data.token);
          setCurrentUser(res.data.user);
          history.replace('/');
        }
      } catch (error) {
        setLoading(false);
        if (error.response) {
          toast.error(error.response.data.message);
        } else {
          toast.error('Something went wrong!');
        }
      }
    } else {
      await verifyUser(data, history);
    }
  };

  const [showPass, setShowPass] = useState(false);

  const togglePassword = () => {
    setShowPass(!showPass);
  };

  const [timer, setTimer] = useState(120);
  const [endTime, setEndTime] = useState(null);

  useEffect(() => {
    if (timer === 120) {
      // Set the end time when timer starts
      setEndTime(Date.now() + 120000);
    }
  }, [timer]);

  useEffect(() => {
    if (!endTime) return;

    const interval = setInterval(() => {
      const remaining = Math.round((endTime - Date.now()) / 1000);
      setTimer(remaining > 0 ? remaining : 0);
    }, 1000);

    return () => clearInterval(interval);
  }, [endTime]);

  const resetTimer = () => {
    setTimer(120);
    setEndTime(null);
  };

  useEffect(() => {
    if (!isVerification) return;
    if (isVerification) {
      resetTimer();
    }
  }, [isVerification]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
  };

  return (
    <form className="authForm" id="loginForm" onSubmit={handleSubmit(submitForm)}>
      <div className="instructions__login">
        <div className="overlay__img d-lg-none d-md-none d-none">
          <Link to="/">
            <img style={{ position: 'relative' }} alt="cedep Logo" src={Logo} />
          </Link>
        </div>

        <div className="overlay__img d-sm-none" style={{ marginTop: '-120px', marginBottom: '50px' }}>
          <Link to="/">
            <img style={{ position: 'relative', width: '90px' }} alt="cedep Logo" src={Logo} />
          </Link>
          <br />
          <br />
        </div>

        <h2 className="Welcome mb-2 pb-0">Get Started!</h2>
        <p className="small text-muted pl-1">To continue, please enter your user credentials.</p>
      </div>
      <div className={errors.phone ? 'errorfield inputGroup' : 'inputGroup'}>
        <input
          ref={register({
            required: 'Phone number is required',
            pattern: {
              value: /^(?:(?:\+|0{0,2})91(\s*[\-]\s*)?|[0]?)?[789]\d{9}$/,
              message: 'Invalid  phone number',
            },
          })}
          name="phone"
          type="number"
          id="phone"
          placeholder="Enter Phone number"
          disabled={!isVerified}
        />
        <label className="input-icon-label" htmlFor="email">
          <i className="fas fa-mobile-alt"></i>
        </label>
      </div>
      <div className="input-error">{errors.phone && errors.phone.message}</div>

      <div className={errors.password ? 'errorfield inputGroup' : 'inputGroup'}>
        <input
          ref={register({
            required: 'Password is required',
            pattern: {
              value: /^.{6,}$/,
              message: 'Password must have at least 6 characters',
            },
          })}
          name="password"
          type={showPass ? 'text' : 'password'}
          id="password"
          placeholder="Password"
          disabled={!isVerified}
        />
        <label className="input-icon-label" htmlFor="email">
          <i className={`fa ${showPass ? 'fa fa-eye-slash' : 'fa fa-eye'}`} onClick={togglePassword}></i>
        </label>
      </div>
      <div className="input-error">{errors.password && errors.password.message}</div>

      {!isVerified && (
        <>
          <div className={errors.token ? 'errorfield inputGroup' : 'inputGroup'}>
            <input
              ref={register({ required: 'Otp code is required' })}
              name="token"
              type="text"
              id="token"
              placeholder="Otp code"
            />
            <label className="input-icon-label" htmlFor="token">
              <i className="fas fa-mobile-alt"></i>
            </label>
          </div>
          <div className="inputGroup pt-3 pb-3 center-block">
            <p className="text-muted small">
              Didn’t receive the OTP?{' '}
              <p
                className="text-muted small"
                onClick={() => {
                  timer === 0 && handleSubmit(submitForm)();
                  setIsVerification(false);
                }}
              >
                Resend OTP&nbsp;
              </p>
              {timer > 0 ? ` in ${timer > 0 && formatTime(timer)}` : ''}
            </p>
          </div>
        </>
      )}

      <div className="forgot__acc d-flex justify-content-end">
        <div className="remember d-inline-block">
          <Link to="/login/reset">
            <label className="forgot text-primary small" htmlFor="remember">
              Forgot Password?
            </label>
          </Link>
        </div>
      </div>
      <div className="d-flex align-items-start" style={{ gap: '10px' }}>
        <input
          type="checkbox"
          name="termsandconditions"
          id="termsandconditions"
          className="mt-1"
          defaultChecked
          ref={register({ required: 'Please agree to terms and conditions' })}
        />
        <p htmlFor="termsandconditions" className="small">
          I agree to the{' '}
          <Link to="/terms-and-conditions" className="text-primary">
            Terms & Conditions
          </Link>{' '}
          and{' '}
          <Link to="/privacy-policy" className="text-primary">
            Privacy Policy
          </Link>
        </p>
      </div>
      <div className="input-error">{errors.termsandconditions && errors.termsandconditions.message}</div>
      <div className="pt-3 ">
        <div className="btn btn-block p-0 my-2">
          <button type="submit" id="login" className="btn btn-dark rounded shadow  mb-2">
            {loading ? <i className="fas fa-spinner fa-spin"></i> : 'Login'}
          </button>
          <Link to="/login/register">
            <button className="btn btn-dark rounded shadow d-block" id="register">
              Create new account&nbsp;<i className="fas fa-arrow-circle-right"></i>
            </button>
          </Link>
        </div>
      </div>
    </form>
  );
}

export default withRouter(LoginFrom);
